
export const weAreHiringAlert = () => {
    var cssRule =
        "color: #160647;" +
        "font-size: 30px;" +
        "font-weight: bold;" +
        "text-shadow: 1px 1px 2px #160647;" +
        "filter: dropshadow(color=#160647, offx=1, offy=1)";
    var cssRule2 =
        "color: #160647;" +
        "font-size: 16px;" +
        "font-weight: bold;";
    setTimeout(console.log.bind(console, "%c2nabsh", cssRule), 0);
    setTimeout(console.log.bind(console, "%cWe are always hiring talented people, contact us: jobs@2nabsh.com", cssRule2), 0);
}